import {
  IconButton,
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import SvgIcon from "../../../components/Images/SvgIcon";
import moment from "moment";
import { startLoader, stopLoader, open_dialog } from "../../../lib/global";
import { DELETE_COLLECTION_MODEL } from "../../../lib/constant";
import { breadcrumbAction } from "../../../redux/actions/config.action";
import { getAllCollections } from "../../../redux/actions/collections.action";

function CollectionsList() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [collectionsData, setCollectionsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(10);

  const fetchCollections = () => {
    startLoader();
    dispatch(getAllCollections({ limit, offset }))
      .then((res) => {
        if (res?.data?.status === 200) {
          setCollectionsData(res.data.data || []);
          setTotalCount(res.data.count || 0);
        } else {
          setCollectionsData([]);
          setTotalCount(0);
        }
        setTimeout(() => stopLoader(), 500);
      })
      .catch(() => {
        setCollectionsData([]);
        setTotalCount(0);
        stopLoader();
      });
  };

  useEffect(() => {
    dispatch(
      breadcrumbAction([
        { label: "Products", url: "/products/all-products" },
        { label: "Collections", url: null },
      ])
    );
  }, [dispatch]);

  useEffect(() => {
    fetchCollections();
  }, [offset]);

  const handlePageChange = (event, value) => {
    setOffset(value - 1);
  };

  const handleDeleteClick = (id) => {
    open_dialog(DELETE_COLLECTION_MODEL, {
      onSubmit: fetchCollections,
      id,
    });
  };

  return (
    <div className="card mx-3 p-3 shadow-sm border-0">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="font-weight-bold mb-1">PRODUCT COLLECTIONS</h5>
          <p className="text-muted mb-0 small">
            Group products into merchandising collections for discounts and section promotion pages.
          </p>
        </div>
        <button
          type="button"
          onClick={() => history.push("/products/collections/add")}
          className="btn btn-dark px-4 py-2 text-nowrap rounded-lg shadow-sm"
        >
          + Add Collection
        </button>
      </div>

      <TableContainer className="border rounded-lg">
        <Table stickyHeader>
          <TableHead className="bg-light">
            <TableRow>
              <TableCell>Collection Name</TableCell>
              <TableCell>Products</TableCell>
              <TableCell>Used In Section Promotions</TableCell>
              <TableCell>Created</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {collectionsData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center" className="py-5 text-muted">
                  No collections found
                </TableCell>
              </TableRow>
            ) : (
              collectionsData.map((row) => (
                <TableRow key={row.collection_id} hover>
                  <TableCell className="font-weight-bold">{row.name}</TableCell>
                  <TableCell>{row.product_count || 0}</TableCell>
                  <TableCell>
                    {row.used_in_section_promotions?.length ? (
                      <div className="d-flex flex-wrap gap-1">
                        {row.used_in_section_promotions.map((promo) => (
                          <span
                            key={promo.section_promotion_id}
                            className="badge badge-light border text-dark mr-1 mb-1"
                          >
                            {promo.section_promotion_name}
                          </span>
                        ))}
                      </div>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </TableCell>
                  <TableCell>
                    {row.created_at
                      ? moment(row.created_at).format("DD MMM YYYY")
                      : "-"}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      onClick={() =>
                        history.push(`/products/collections/edit/${row.collection_id}`)
                      }
                    >
                      <SvgIcon src="/icons/edit_icon.svg" alt="edit" />
                    </IconButton>
                    <IconButton onClick={() => handleDeleteClick(row.collection_id)}>
                      <SvgIcon src="/icons/delete_icon.svg" alt="delete" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {totalCount > limit && (
        <div className="d-flex justify-content-end mt-3">
          <Stack spacing={2}>
            <Pagination
              count={Math.ceil(totalCount / limit)}
              page={offset + 1}
              shape="rounded"
              size="small"
              onChange={handlePageChange}
            />
          </Stack>
        </div>
      )}
    </div>
  );
}

export default CollectionsList;
